import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconXMark = createIcon({
  viewBox: '0 0 100 100',
  path: (
    <>
      <defs>
        <path
          id="p9r4yebyra"
          d="M33.333 66.667C14.923 66.667 0 51.743 0 33.333 0 14.923 14.924 0 33.333 0c18.41 0 33.334 14.924 33.334 33.333 0 18.41-14.924 33.334-33.334 33.334zm5.19-32.64l11.24-11.239c1.242-1.241 1.242-3.254 0-4.496-1.241-1.241-3.254-1.241-4.496 0l-11.24 11.24-11.239-11.24c-1.241-1.241-3.254-1.241-4.496 0-1.241 1.242-1.241 3.255 0 4.496l11.24 11.24-11.24 11.24c-1.241 1.241-1.241 3.254 0 4.495 1.242 1.242 3.255 1.242 4.496 0l11.24-11.24 11.24 11.24c1.241 1.242 3.254 1.242 4.495 0 1.242-1.241 1.242-3.254 0-4.496l-11.24-11.24z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0H100V100H0z"
                transform="translate(-132 -124) translate(24 124) translate(108)"
              />
              <g transform="translate(-132 -124) translate(24 124) translate(108) translate(16.667 16.667)">
                <mask id="zuig1mmiqb" fill="#fff">
                  <use xlinkHref="#p9r4yebyra" />
                </mask>
                <use fill="#2D3237" xlinkHref="#p9r4yebyra" />
                <g fill="#D33" mask="url(#zuig1mmiqb)">
                  <path
                    d="M0 0H100V100H0z"
                    transform="translate(-16.25 -16.25)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </>
  ),
});

export default IconXMark;
